import { parseAsJson, useQueryState } from 'next-usequerystate'
import { useCallback, useMemo } from 'react'

import { QueryParam } from '../constants/query'
import { EMPTY_SEND_RFQ_PARAMS, SendRfqParams, SetRfqParams } from '../constants/rfqs'
import { parseRfqParams } from '../utils/rfqs'

export default function useRfqQueryParams(): [SendRfqParams, SetRfqParams] {
  const [_sendRfqParams, _setSendRfqParams] = useQueryState<SendRfqParams>(
    QueryParam.OrderParams,
    parseAsJson(parseRfqParams).withDefault(EMPTY_SEND_RFQ_PARAMS)
  )

  const rfqParams = useMemo(
    () => parseRfqParams(_sendRfqParams) ?? EMPTY_SEND_RFQ_PARAMS,
    [_sendRfqParams]
  )

  const setRfqParams: SetRfqParams = useCallback(
    (valueOrFunc) =>
      _setSendRfqParams(typeof valueOrFunc === 'function' ? valueOrFunc(rfqParams) : valueOrFunc),
    [rfqParams, _setSendRfqParams]
  )

  return useMemo(() => {
    return [rfqParams, setRfqParams]
  }, [rfqParams, setRfqParams])
}
